module.exports = __webpack_public_path__ + "static/media/mainChart.7075ddbb.png";